import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SupportAccountService } from '../../services/support/support-account.service';
import { CommonfilterService } from '../../services/commonfilter.service';
import { SupportAccountDataSourceService } from '../../services/support/support-account-data-source.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationService } from '../../services/pagination.service';
import { VerifyAccountDialogComponent } from '../../shared/components/verify-account-dialog/verify-account-dialog.component';
import { DataSource } from '@angular/cdk/table';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable ,  of ,  fromEvent } from 'rxjs';
import { catchError, finalize, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { VerifyModalComponent } from '../../shared/components/verify-modal/verify-modal.component';
import { EmailVerifyDialogComponent } from '../../shared/components/email-verify-dialog/email-verify-dialog.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-support-accounts',
  templateUrl: './support-accounts.component.html',
  styleUrls: ['./support-accounts.component.css']
})
export class SupportAccountsComponent implements OnInit, AfterViewInit {
  accountCount: number;

  tableFilters = '';

  accountData: any = {};

  selectedRowIndex = -1;

  selectAccountname = '';

  showToolBar = false;

  serviceSectors: any;

  subDomains: any;

  subDomain: any;

  baseLocation: any;

  collapsed: any;

  baseLocationModel: any;


  displayedColumns = ['id', 'businessName', 'serviceSector', 'serviceSubSector', 'baseLocation', 'verification', 'status', 'createdDate'];

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) button: ElementRef;
  hidden: boolean;

  accountDetails: any;
  type = 'add';
  domain: any;
  accountCompleteInfo: any;

  constructor(
    private support_accountService: SupportAccountService,
    private commomFilterService: CommonfilterService,
    private support_accData: SupportAccountDataSourceService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private pagination: PaginationService) {

  this.support_accData.cast.subscribe(accountCount => {this.accountCount = accountCount; });

   }
   dataSource = new AccountDataSource(this.support_accountService, this.support_accData);
  ngOnInit() {

    this.tableFilters = '';
    this.getTotalCount(this.tableFilters);
    this.dataSource.loadAccountData( this.tableFilters, 'false', 0, 100);
    const  value = this.route.snapshot.paramMap.get('operation');
   if (value === 'login') {
   this.hidden = true;
   } else {
    this.hidden = false;
   }
  }


  ngAfterViewInit() {

    this.paginator.page
    .pipe(
        tap(() => this.loadAccountsPage())
    )
    .subscribe();


    fromEvent(this.button.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
            this.tableFilters = this.commomFilterService.createfilterParams('account');
            this.getTotalCount(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadAccountsPage();

        })
    )
    .subscribe();

}
onRowClicked(row) {

  this.selectedRowIndex = row.account.id;
  this.accountDetails = row.account;
  this.showToolBar = true;
  this.accountCompleteInfo = row;
}



  // verify(){
  //  if((this.accountDetails.verifyLevel==="BASIC")||(this.accountDetails.verifyLevel==="YNW_ASSURED"))
  //   this.type="edit";
  //  else
  //   this.type="add";
  // let dialogRef = this.dialog.open(VerifyAccountDialogComponent, {
  //   data: {"account":this.accountDetails,"type":this.type}
  // });

  // dialogRef.afterClosed().subscribe(result => {
  //   this.selectedRowIndex=-1;
  //   this.loadAccountsPage();

  // });

  // }


  verify() {

    if ((this.accountDetails.verifyLevel === 'NONE')) {
    this.type = 'add';
    } else {
    this.type = 'edit';
    }
  const dialogRef = this.dialog.open(VerifyAccountDialogComponent, {
    data: {'account': this.accountCompleteInfo, 'type': this.type}
  });

  dialogRef.afterClosed().subscribe(result => {
    this.selectedRowIndex = -1;
    this.showToolBar = false;
    this.loadAccountsPage();

  });


   }


   reject_mail() {
    const dialogRef = this.dialog.open(EmailVerifyDialogComponent, {
      width: '900px',
      height: 'auto',
      data: {'account': this.accountCompleteInfo, 'type': 'provider'}
    });

    dialogRef.afterClosed().subscribe(result => {

  });
   }
  logintoAccount() {

      const dialogRef = this.dialog.open(VerifyModalComponent, {
        width: '600px',
        data: this.accountDetails

      });

      dialogRef.afterClosed().subscribe(result => {

      });



  }
loadAccountsPage() {

  const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;

  this.dataSource.loadAccountData(
    this.tableFilters,
    'false',
    count,
    this.paginator.pageSize);
}
 getTotalCount(tablefilter) {
   this.support_accountService.getTotalFilterCount(tablefilter)
  .subscribe( res => {this.support_accData.setAccountCount(res);
    this.accountCount = res; });
 }

 onDomainChange(event) {

  this.subDomains = [];
  for (let i = 0; i < this.serviceSectors.length; i++) {
    if (this.serviceSectors[i].id === event.target.value) {
      this.domain = this.serviceSectors[i].domain;
      for (let j = 0; j < this.serviceSectors[i].subDomains.length; j++) {
        this.subDomains.push({'displayName': this.serviceSectors[i].subDomains[j].displayName,
         'id': this.serviceSectors[i].subDomains[j].id, 'subDomain': this.serviceSectors[i].subDomains[j].subDomain});
        }
      }

    }

  }


}

export class AccountDataSource implements DataSource<any> {


  constructor(private support_accountService: SupportAccountService, private support_accData: SupportAccountDataSourceService) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any> {
     return this.support_accData.accountSubject.asObservable();

  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.support_accData.accountSubject.complete();
    this.support_accData.loadingSubject.complete();
  }

  loadAccountData( filter,
  sortDirection, count, pageSize) {

  this.support_accData.loadingSubject.next(true);

   this.support_accountService.getAccountsData( filter, sortDirection,
    count, pageSize).pipe(
     catchError(() => of([])),
       finalize(() => this.support_accData.loadingSubject.next(false))
     )
    .subscribe(
      accounts => {
        this.support_accData.accountSubject.next(accounts);
       }
     );
  }

}
